module.exports = __webpack_public_path__ + "media/images/landing/logo-mybenefits-inverse-ec9c55c7680e51d9a12f6d343fa72aef.svg";